import BaseService from '@src/services/BaseService'

class UserPerformanceConfig extends BaseService {
  constructor() {
    super('user-performance-config')
  }
}

export default new UserPerformanceConfig()
